import { render, staticRenderFns } from "./tree-path.vue?vue&type=template&id=5d5eb049"
import script from "./tree-path.vue?vue&type=script&lang=ts"
export * from "./tree-path.vue?vue&type=script&lang=ts"
import style0 from "./tree-path.vue?vue&type=style&index=0&id=5d5eb049&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5eb049')) {
      api.createRecord('5d5eb049', component.options)
    } else {
      api.reload('5d5eb049', component.options)
    }
    module.hot.accept("./tree-path.vue?vue&type=template&id=5d5eb049", function () {
      api.rerender('5d5eb049', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/tree-path.vue"
export default component.exports